export default __webpack_public_path__ + "static/media/wwc.1732f700.png";